module.exports = __webpack_public_path__ + "assets/img/pic3.9e1f89b8.png";